function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../../geom/Location';
import TreeSet from '../../../../../java/util/TreeSet';
import LineString from '../../geom/LineString';
import Geometry from '../../geom/Geometry';
import ConnectedInteriorTester from './ConnectedInteriorTester';
import Coordinate from '../../geom/Coordinate';
import Point from '../../geom/Point';
import Polygon from '../../geom/Polygon';
import MultiPoint from '../../geom/MultiPoint';
import PointLocation from '../../algorithm/PointLocation';
import LinearRing from '../../geom/LinearRing';
import Double from '../../../../../java/lang/Double';
import GeometryGraph from '../../geomgraph/GeometryGraph';
import MultiPolygon from '../../geom/MultiPolygon';
import ConsistentAreaTester from './ConsistentAreaTester';
import GeometryCollection from '../../geom/GeometryCollection';
import UnsupportedOperationException from '../../../../../java/lang/UnsupportedOperationException';
import IndexedNestedRingTester from './IndexedNestedRingTester';
import RobustLineIntersector from '../../algorithm/RobustLineIntersector';
import TopologyValidationError from './TopologyValidationError';
import IndexedPointInAreaLocator from '../../algorithm/locate/IndexedPointInAreaLocator';
import Assert from '../../util/Assert';
var IsValidOp = /*#__PURE__*/function () {
  function IsValidOp() {
    _classCallCheck(this, IsValidOp);
    IsValidOp.constructor_.apply(this, arguments);
  }
  return _createClass(IsValidOp, [{
    key: "checkInvalidCoordinates",
    value: function checkInvalidCoordinates() {
      if (arguments[0] instanceof Array) {
        var coords = arguments[0];
        for (var i = 0; i < coords.length; i++) {
          if (!IsValidOp.isValid(coords[i])) {
            this._validErr = new TopologyValidationError(TopologyValidationError.INVALID_COORDINATE, coords[i]);
            return null;
          }
        }
      } else if (arguments[0] instanceof Polygon) {
        var poly = arguments[0];
        this.checkInvalidCoordinates(poly.getExteriorRing().getCoordinates());
        if (this._validErr !== null) return null;
        for (var _i = 0; _i < poly.getNumInteriorRing(); _i++) {
          this.checkInvalidCoordinates(poly.getInteriorRingN(_i).getCoordinates());
          if (this._validErr !== null) return null;
        }
      }
    }
  }, {
    key: "checkHolesNotNested",
    value: function checkHolesNotNested(p, graph) {
      var nestedTester = new IndexedNestedRingTester(graph);
      for (var i = 0; i < p.getNumInteriorRing(); i++) {
        var innerHole = p.getInteriorRingN(i);
        nestedTester.add(innerHole);
      }
      var isNonNested = nestedTester.isNonNested();
      if (!isNonNested) {
        this._validErr = new TopologyValidationError(TopologyValidationError.NESTED_HOLES, nestedTester.getNestedPoint());
      }
    }
  }, {
    key: "checkConsistentArea",
    value: function checkConsistentArea(graph) {
      var cat = new ConsistentAreaTester(graph);
      var isValidArea = cat.isNodeConsistentArea();
      if (!isValidArea) {
        this._validErr = new TopologyValidationError(TopologyValidationError.SELF_INTERSECTION, cat.getInvalidPoint());
        return null;
      }
      if (cat.hasDuplicateRings()) {
        this._validErr = new TopologyValidationError(TopologyValidationError.DUPLICATE_RINGS, cat.getInvalidPoint());
      }
    }
  }, {
    key: "isValid",
    value: function isValid() {
      this.checkValid(this._parentGeometry);
      return this._validErr === null;
    }
  }, {
    key: "checkShellInsideHole",
    value: function checkShellInsideHole(shell, hole, graph) {
      var shellPts = shell.getCoordinates();
      var holePts = hole.getCoordinates();
      var shellPt = IsValidOp.findPtNotNode(shellPts, hole, graph);
      if (shellPt !== null) {
        var insideHole = PointLocation.isInRing(shellPt, holePts);
        if (!insideHole) {
          return shellPt;
        }
      }
      var holePt = IsValidOp.findPtNotNode(holePts, shell, graph);
      if (holePt !== null) {
        var insideShell = PointLocation.isInRing(holePt, shellPts);
        if (insideShell) {
          return holePt;
        }
        return null;
      }
      Assert.shouldNeverReachHere('points in shell and hole appear to be equal');
      return null;
    }
  }, {
    key: "checkNoSelfIntersectingRings",
    value: function checkNoSelfIntersectingRings(graph) {
      for (var i = graph.getEdgeIterator(); i.hasNext();) {
        var e = i.next();
        this.checkNoSelfIntersectingRing(e.getEdgeIntersectionList());
        if (this._validErr !== null) return null;
      }
    }
  }, {
    key: "checkConnectedInteriors",
    value: function checkConnectedInteriors(graph) {
      var cit = new ConnectedInteriorTester(graph);
      if (!cit.isInteriorsConnected()) this._validErr = new TopologyValidationError(TopologyValidationError.DISCONNECTED_INTERIOR, cit.getCoordinate());
    }
  }, {
    key: "checkNoSelfIntersectingRing",
    value: function checkNoSelfIntersectingRing(eiList) {
      var nodeSet = new TreeSet();
      var isFirst = true;
      for (var i = eiList.iterator(); i.hasNext();) {
        var ei = i.next();
        if (isFirst) {
          isFirst = false;
          continue;
        }
        if (nodeSet.contains(ei.coord)) {
          this._validErr = new TopologyValidationError(TopologyValidationError.RING_SELF_INTERSECTION, ei.coord);
          return null;
        } else {
          nodeSet.add(ei.coord);
        }
      }
    }
  }, {
    key: "checkHolesInShell",
    value: function checkHolesInShell(p, graph) {
      var shell = p.getExteriorRing();
      var pir = new IndexedPointInAreaLocator(shell);
      for (var i = 0; i < p.getNumInteriorRing(); i++) {
        var hole = p.getInteriorRingN(i);
        var holePt = IsValidOp.findPtNotNode(hole.getCoordinates(), shell, graph);
        if (holePt === null) return null;
        var outside = Location.EXTERIOR === pir.locate(holePt);
        if (outside) {
          this._validErr = new TopologyValidationError(TopologyValidationError.HOLE_OUTSIDE_SHELL, holePt);
          return null;
        }
      }
    }
  }, {
    key: "checkTooFewPoints",
    value: function checkTooFewPoints(graph) {
      if (graph.hasTooFewPoints()) {
        this._validErr = new TopologyValidationError(TopologyValidationError.TOO_FEW_POINTS, graph.getInvalidPoint());
        return null;
      }
    }
  }, {
    key: "getValidationError",
    value: function getValidationError() {
      this.checkValid(this._parentGeometry);
      return this._validErr;
    }
  }, {
    key: "checkValid",
    value: function checkValid() {
      if (arguments[0] instanceof Point) {
        var g = arguments[0];
        this.checkInvalidCoordinates(g.getCoordinates());
      } else if (arguments[0] instanceof MultiPoint) {
        var _g = arguments[0];
        this.checkInvalidCoordinates(_g.getCoordinates());
      } else if (arguments[0] instanceof LinearRing) {
        var _g2 = arguments[0];
        this.checkInvalidCoordinates(_g2.getCoordinates());
        if (this._validErr !== null) return null;
        this.checkClosedRing(_g2);
        if (this._validErr !== null) return null;
        var graph = new GeometryGraph(0, _g2);
        this.checkTooFewPoints(graph);
        if (this._validErr !== null) return null;
        var li = new RobustLineIntersector();
        graph.computeSelfNodes(li, true, true);
        this.checkNoSelfIntersectingRings(graph);
      } else if (arguments[0] instanceof LineString) {
        var _g3 = arguments[0];
        this.checkInvalidCoordinates(_g3.getCoordinates());
        if (this._validErr !== null) return null;
        var _graph = new GeometryGraph(0, _g3);
        this.checkTooFewPoints(_graph);
      } else if (arguments[0] instanceof Polygon) {
        var _g4 = arguments[0];
        this.checkInvalidCoordinates(_g4);
        if (this._validErr !== null) return null;
        this.checkClosedRings(_g4);
        if (this._validErr !== null) return null;
        var _graph2 = new GeometryGraph(0, _g4);
        this.checkTooFewPoints(_graph2);
        if (this._validErr !== null) return null;
        this.checkConsistentArea(_graph2);
        if (this._validErr !== null) return null;
        if (!this._isSelfTouchingRingFormingHoleValid) {
          this.checkNoSelfIntersectingRings(_graph2);
          if (this._validErr !== null) return null;
        }
        this.checkHolesInShell(_g4, _graph2);
        if (this._validErr !== null) return null;
        this.checkHolesNotNested(_g4, _graph2);
        if (this._validErr !== null) return null;
        this.checkConnectedInteriors(_graph2);
      } else if (arguments[0] instanceof MultiPolygon) {
        var _g5 = arguments[0];
        for (var i = 0; i < _g5.getNumGeometries(); i++) {
          var p = _g5.getGeometryN(i);
          this.checkInvalidCoordinates(p);
          if (this._validErr !== null) return null;
          this.checkClosedRings(p);
          if (this._validErr !== null) return null;
        }
        var _graph3 = new GeometryGraph(0, _g5);
        this.checkTooFewPoints(_graph3);
        if (this._validErr !== null) return null;
        this.checkConsistentArea(_graph3);
        if (this._validErr !== null) return null;
        if (!this._isSelfTouchingRingFormingHoleValid) {
          this.checkNoSelfIntersectingRings(_graph3);
          if (this._validErr !== null) return null;
        }
        for (var _i2 = 0; _i2 < _g5.getNumGeometries(); _i2++) {
          var _p = _g5.getGeometryN(_i2);
          this.checkHolesInShell(_p, _graph3);
          if (this._validErr !== null) return null;
        }
        for (var _i3 = 0; _i3 < _g5.getNumGeometries(); _i3++) {
          var _p2 = _g5.getGeometryN(_i3);
          this.checkHolesNotNested(_p2, _graph3);
          if (this._validErr !== null) return null;
        }
        this.checkShellsNotNested(_g5, _graph3);
        if (this._validErr !== null) return null;
        this.checkConnectedInteriors(_graph3);
      } else if (arguments[0] instanceof GeometryCollection) {
        var gc = arguments[0];
        for (var _i4 = 0; _i4 < gc.getNumGeometries(); _i4++) {
          var _g6 = gc.getGeometryN(_i4);
          this.checkValid(_g6);
          if (this._validErr !== null) return null;
        }
      } else if (arguments[0] instanceof Geometry) {
        var _g7 = arguments[0];
        this._validErr = null;
        if (_g7.isEmpty()) return null;
        if (_g7 instanceof Point) this.checkValid(_g7);else if (_g7 instanceof MultiPoint) this.checkValid(_g7);else if (_g7 instanceof LinearRing) this.checkValid(_g7);else if (_g7 instanceof LineString) this.checkValid(_g7);else if (_g7 instanceof Polygon) this.checkValid(_g7);else if (_g7 instanceof MultiPolygon) this.checkValid(_g7);else if (_g7 instanceof GeometryCollection) this.checkValid(_g7);else throw new UnsupportedOperationException(_g7.getClass().getName());
      }
    }
  }, {
    key: "setSelfTouchingRingFormingHoleValid",
    value: function setSelfTouchingRingFormingHoleValid(isValid) {
      this._isSelfTouchingRingFormingHoleValid = isValid;
    }
  }, {
    key: "checkShellNotNested",
    value: function checkShellNotNested(shell, p, graph) {
      var shellPts = shell.getCoordinates();
      var polyShell = p.getExteriorRing();
      var polyPts = polyShell.getCoordinates();
      var shellPt = IsValidOp.findPtNotNode(shellPts, polyShell, graph);
      if (shellPt === null) return null;
      var insidePolyShell = PointLocation.isInRing(shellPt, polyPts);
      if (!insidePolyShell) return null;
      if (p.getNumInteriorRing() <= 0) {
        this._validErr = new TopologyValidationError(TopologyValidationError.NESTED_SHELLS, shellPt);
        return null;
      }
      var badNestedPt = null;
      for (var i = 0; i < p.getNumInteriorRing(); i++) {
        var hole = p.getInteriorRingN(i);
        badNestedPt = this.checkShellInsideHole(shell, hole, graph);
        if (badNestedPt === null) return null;
      }
      this._validErr = new TopologyValidationError(TopologyValidationError.NESTED_SHELLS, badNestedPt);
    }
  }, {
    key: "checkClosedRings",
    value: function checkClosedRings(poly) {
      this.checkClosedRing(poly.getExteriorRing());
      if (this._validErr !== null) return null;
      for (var i = 0; i < poly.getNumInteriorRing(); i++) {
        this.checkClosedRing(poly.getInteriorRingN(i));
        if (this._validErr !== null) return null;
      }
    }
  }, {
    key: "checkClosedRing",
    value: function checkClosedRing(ring) {
      if (!ring.isClosed()) {
        var pt = null;
        if (ring.getNumPoints() >= 1) pt = ring.getCoordinateN(0);
        this._validErr = new TopologyValidationError(TopologyValidationError.RING_NOT_CLOSED, pt);
      }
    }
  }, {
    key: "checkShellsNotNested",
    value: function checkShellsNotNested(mp, graph) {
      for (var i = 0; i < mp.getNumGeometries(); i++) {
        var p = mp.getGeometryN(i);
        var shell = p.getExteriorRing();
        for (var j = 0; j < mp.getNumGeometries(); j++) {
          if (i === j) continue;
          var p2 = mp.getGeometryN(j);
          this.checkShellNotNested(shell, p2, graph);
          if (this._validErr !== null) return null;
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IsValidOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "findPtNotNode",
    value: function findPtNotNode(testCoords, searchRing, graph) {
      var searchEdge = graph.findEdge(searchRing);
      var eiList = searchEdge.getEdgeIntersectionList();
      for (var i = 0; i < testCoords.length; i++) {
        var pt = testCoords[i];
        if (!eiList.isIntersection(pt)) return pt;
      }
      return null;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (arguments[0] instanceof Geometry) {
        var geom = arguments[0];
        var isValidOp = new IsValidOp(geom);
        return isValidOp.isValid();
      } else if (arguments[0] instanceof Coordinate) {
        var coord = arguments[0];
        if (Double.isNaN(coord.x)) return false;
        if (Double.isInfinite(coord.x)) return false;
        if (Double.isNaN(coord.y)) return false;
        if (Double.isInfinite(coord.y)) return false;
        return true;
      }
    }
  }]);
}();
export { IsValidOp as default };
IsValidOp.constructor_ = function () {
  this._parentGeometry = null;
  this._isSelfTouchingRingFormingHoleValid = false;
  this._validErr = null;
  var parentGeometry = arguments[0];
  this._parentGeometry = parentGeometry;
};